import { isEmpty } from 'lodash';

export const findNotSelectedUsers = (users, selectedUsers) =>
  users?.filter((user) =>
    isEmpty(selectedUsers?.filter((shopUser) => shopUser.userId === user.userId))
  );
